import { MutableRefObject, useLayoutEffect, useState } from 'react';
import { RenderPosition } from '../enums/RenderPosition';

export const useRenderPosition = (
  ref: MutableRefObject<HTMLElement | null>,
  height: number = 50,
): RenderPosition => {
  const [renderPosition, setRenderPosition] = useState<RenderPosition>(RenderPosition.Bottom);

  useLayoutEffect(() => {
    getRenderPosition();
  }, []);

  const getRenderPosition = () => {
    if (ref?.current) {
      const rect = ref.current.getBoundingClientRect();
      const willItFit =
        rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) - height;
      const willItFitTop = rect.height <= rect.top - height;
      willItFit
        ? setRenderPosition(RenderPosition.Bottom)
        : willItFitTop
          ? setRenderPosition(RenderPosition.Top)
          : setRenderPosition(RenderPosition.Bottom);
    }
  };
  return renderPosition;
};
